import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { sportIds } from 'src/constants'
import { canadaPlanSet, canadaSports_EPL_UCL_Override } from 'src/constants/planData/canadaPlanData'

export default (props) => {
  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/OneSoccer_LP_30s.mp4'}
      title="Watch OneSoccer with Fubo"
      subtitle="The home of Canadian soccer"
      networkSet="canada_sports"
      sportId={sportIds.Soccer}
      planCardsConfig={{
        plans: canadaPlanSet.sports,
        overrides: canadaSports_EPL_UCL_Override,
      }}
    />
  )
}
